export default "__VITE_ASSET__f4fe9f6a__"